export enum SupportedBy {
  MERCHANT = 'MERCHANT',
  FI = 'FI',
}
